import yaml from 'js-yaml';

export type StreamEntityKey = 'productDefinitions' | 'teamDefinitions' | 'tenantDefinitions';

const ENTITY_KEY_ALIASES: Record<StreamEntityKey, string[]> = {
  productDefinitions: ['productDefinitions', 'product_definitions'],
  teamDefinitions: ['teamDefinitions', 'team_definitions'],
  tenantDefinitions: ['tenantDefinitions', 'tenant_definitions'],
};

export function parseEntityDefinitionsFromStreamYaml<T = any>(
  yamlContent: string,
  entityKey: StreamEntityKey,
): T[] {
  if (!yamlContent?.trim()) return [];

  try {
    const parsed = yaml.load(yamlContent) as any;
    const root = parsed?.stream ?? parsed ?? {};
    const keys = ENTITY_KEY_ALIASES[entityKey];

    for (const key of keys) {
      if (Array.isArray(root?.[key])) {
        return root[key] as T[];
      }
    }

    return [];
  } catch {
    return [];
  }
}

export function stripManageEntitySourceFields<T extends Record<string, any>>(row: T): Omit<T, 'sourceStreamId' | 'sourceStreamLabel'> {
  const { sourceStreamId: _sourceStreamId, sourceStreamLabel: _sourceStreamLabel, ...entityConfig } = row;
  return entityConfig as Omit<T, 'sourceStreamId' | 'sourceStreamLabel'>;
}
